<app-header></app-header>
<div class="main-wrapper" tabindex="1" [hidden]="isDisplayCityMap">
  <div class="main-inner-wrapper">
    <!-- viewing the world map while the party is inside a city -->
    <div class="mv-notice" *ngIf="displayHeader" role="status">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
        <path d="M12 11v5M12 7.5h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <span><strong>Viewing only.</strong> The party token is inside a city, so it can't be moved on this map.</span>
      <button type="button" class="btn btn-dark btn-sm" (click)="continuePlaying()">Continue playing</button>
    </div>
    <div class="mapWrap game-master-map" [style.marginLeft]="isMenu2Open ? '400px' : isMenu1Open ? '200px' : '0px'"
      style="
        width: calc(auto - 400px);
        background-color: white;
        overflow: hidden;
      " id="map" #map [ngStyle]="{ height: windowmapheight }" (contextmenu)="onRightClickPopup($event)"></div>

    <!-- right-click menu: what to do at this spot -->
    <div class="map-ctx" *ngIf="showMenu" [style.top.px]="menuPosition.y" [style.left.px]="menuPosition.x" role="menu">
      <div class="map-ctx-head">
        <span>At this spot</span>
        <button type="button" class="map-ctx-close" (click)="showMenu = false" aria-label="Close"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>
      </div>
      <button type="button" class="map-ctx-item" role="menuitem" (click)="createContent()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Create new content</span><i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i></button>
      <button type="button" class="map-ctx-item" role="menuitem" (click)="browseWpStore()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 9h16l-1.2 10.2a1 1 0 0 1-1 .8H6.2a1 1 0 0 1-1-.8L4 9Zm4 0V7a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span>Browse store content</span></button>
      <button type="button" class="map-ctx-item" role="menuitem" (click)="openPlaceContentModal()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 7h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7Zm-1-3h18v3H3V4Zm6 7h6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/></svg><span>Add from your vault</span></button>
    </div>

    <nav class="atlas-breadcrumb" aria-label="Map location">
      <a (click)="navigateToWikiWorld()">{{ map_name || 'World' }}</a>
      <!-- State / Province / City crumbs join here once the selection-state
           service (Phase 3 of the map redesign) tracks what's selected. -->
    </nav>

    <div class="map-top-header">
      <div class="dmenu-outer">
        <div class="dmenu" (click)="openSideDropdownOption()">
          <img src="assets/icons/down-arrow-white.svg" alt="" />
        </div>
        <div>
          <ul class="dropdown-options" *ngIf="showDropdown">
            <li (click)="setSelectOption('Favourite')">
              Favorites
              <svg _ngcontent-cmp-c112="" width="10" height="17" viewBox="0 0 10 17" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path _ngcontent-cmp-c112="" d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </li>
            <li (click)="setSelectOption('Journal')">
              Journal
              <svg _ngcontent-cmp-c112="" width="10" height="17" viewBox="0 0 10 17" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path _ngcontent-cmp-c112="" d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </li>
          </ul>
          <div class="parent-container" [ngSwitch]="selectedOption">
            <ng-container>
              <div class="favorites-modal" *ngSwitchCase="'Favourite'">
                <div class="header">
                  <h4>Favorites</h4>
                  <button class="close-button" (click)="closeSecondMenu()">
                    <img src="assets/icons/icon-close.svg" alt="" />
                  </button>
                </div>
                <div class="favorites-body"
                  *ngIf="favroiteRecords && favroiteRecords.length > 0; else noFavroiteRecords">
                  <div class="form-check-box" *ngFor="let record of favroiteRecords; let i = index">
                    <div class="form-check-b">
                      <input type="checkbox" value="" id="cb{{ i }}" />
                      <label>{{ record.title }}</label>
                    </div>
                    <span *ngIf="isRemovingFavorite !== record.wp_content_usage_id">
                      <img src="assets/icons/icon-close.svg" alt="" (click)="removeFromFavroite(record)"
                        style="cursor:pointer;" />
                    </span>
                    <span *ngIf="isRemovingFavorite === record.wp_content_usage_id">
                      <div class="spinner-border spinner-border-sm text-light" role="status"></div>
                    </span>
                  </div>
                </div>
                <ng-template #noFavroiteRecords>
                  <p class="text-center text-white mt-3">No favorite records found.</p>
                </ng-template>
              </div>

              <div class="favorites-modal" *ngSwitchCase="'Journal'">
                <div class="header">
                  <h4>JOURNAL</h4>
                  <button class="close-button">
                    <img src="assets/icons/icon-close.svg" alt="" (click)="closeSecondMenu()" />
                  </button>
                </div>
                <div class="favorites-body history-body" *ngIf="
                    historyRecords && historyRecords.length > 0;
                    else noJournalRecords
                  ">
                  <ng-container *ngFor="let journalEntry of historyRecords; let i = index">
                    <!-- Parent Entry -->
                    <div class="form-check-box">
                      <div class="form-check-b">
                        <input type="checkbox" id="cb{{ i }}" [value]="journalEntry.id"
                          [(ngModel)]="journalEntry.selected" (change)="journalCheckBoxChange($event, i)" />

                        <div class="title-row">
                          <label (click)="
                              journalEntry.expanded = !journalEntry.expanded;
                              $event.stopPropagation()
                            ">
                            {{ journalEntry.title }}</label>

                          <!-- Expand arrow -->
                          <svg *ngIf="journalEntry.children?.length" class="expand-svg" (click)="
                              journalEntry.expanded = !journalEntry.expanded
                            " [ngClass]="{ rotated: journalEntry.expanded }" width="12" height="12" viewBox="0 0 24 24"
                            fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px">
                            <path d="M8 5L15 12L8 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>

                          <!-- Edit icon -->
                          <img class="edit-icon" src="assets/icons/icon-edit-white.svg" (click)="
                              editDetail(journalEntry, false);
                              $event.stopPropagation()
                            " />
                        </div>
                      </div>
                    </div>

                    <!-- Child Entries -->
                    <div class="child-entry-box" *ngIf="journalEntry.expanded">
                      <div class="form-check-box child-entry" *ngFor="
                          let child of journalEntry.children;
                          let ci = index
                        ">
                        <div class="form-check-b">
                          <label>{{ child.title }}</label>
                          <span>
                            <img src="assets/icons/icon-edit-white.svg" alt="" (click)="
                                editDetail(child, true);
                                $event.stopPropagation()
                              " />
                          </span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <ng-template #noJournalRecords>
                  <p class="text-center text-white">
                    No journal records found.
                  </p>
                </ng-template>
              </div>

              <div class="gmtool-modal" *ngSwitchCase="'GMTools'">
                <div class="header">
                  <h4>Game Master Tools</h4>
                  <button class="close-button" (click)="closeSecondMenu()">
                    <img src="assets/icons/icon-close.svg" alt="" />
                  </button>
                </div>
                <div class="gmtool-body">
                  <p>Expose Map Area</p>
                  <p>Teleport Party Token</p>
                  <p>Expose Whole Map</p>
                  <p (click)="addNote(true)">Private Note</p>
                  <p (click)="addNote(false)">Public Note</p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="map-search-box">
        <input class="map-search-input" type="text" [placeholder]="searchPlaceholder" [(ngModel)]="searchQuery"
          (input)="onSearchInput()" (keydown.enter)="runSearch(searchQuery)" (keydown.escape)="clearSearch()" />
        <button class="map-search-btn" (click)="runSearch(searchQuery)">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="13.9908" cy="14.2886" r="8.16459" stroke="#002B4E" stroke-width="2.72153" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M20.1134 20.4121L26.2368 26.5356" stroke="#002B4E" stroke-width="2.72153" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>

        <div class="atlas-search-results" *ngIf="searchQuery && (searchResults.length || searchLoading)">
          <div class="atlas-search-loading" *ngIf="searchLoading">Searching…</div>
          <ng-container *ngIf="!searchLoading">
            <button type="button" class="atlas-search-result" *ngFor="let r of searchResults"
              (click)="selectSearchResult(r)">
              <span class="atlas-search-result-type">{{ r.type }}</span>
              <span class="atlas-search-result-name">{{ r.name }}</span>
              <span class="atlas-search-result-meta" *ngIf="r.state && r.type !== 'state'">{{ r.state }}</span>
            </button>
            <p class="atlas-search-empty" *ngIf="!searchResults.length">No matches</p>
          </ng-container>
        </div>
      </div>

      <div class="btn-map-icon">
        <button type="button" class="btnmap" (click)="triggerTokenZoom()" title="Go to the party token" aria-label="Go to the party token">
          <img src="assets/icons/icon-map-location.svg" alt="" />
        </button>
        <button type="button" class="btnmap" (click)="triggerZoomIn()" title="Zoom in" aria-label="Zoom in">
          <img src="assets/icons/icon-map-plus.svg" alt="" />
        </button>
        <button type="button" class="btnmap" (click)="triggerZoomOut()" title="Zoom out" aria-label="Zoom out">
          <img src="assets/icons/icon-map-minus.svg" alt="" />
        </button>
        <button type="button" class="btnmap" disabled title="Export - coming soon" aria-label="Export - coming soon">
          <svg class="btnmap-export-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M12 3v12m0 0l-4-4m4 4l4-4M5 19h14" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Atlas Rail (spec §5): Map mode today (layer toggle + key, Phase 2
         redesigns this into a single-select "Color map by" grid); Explore
         mode (Locale/Town/Street) is a Phase 4 placeholder for now. -->
    <div class="atlas-rail">
      <a class="atlas-rail-back" [routerLink]="['/activegames']">&lsaquo; Back to world list</a>

      <ng-container *ngIf="railMode === 'map'; else exploreRail">
        <p class="atlas-colorby-eyebrow">COLOR MAP BY</p>
        <div class="atlas-colorby-grid">
          <button type="button" class="atlas-colorby-box" *ngFor="let btn of filterlayers(layerlist)"
            [class.active]="btn.checked" [class.soon]="btn.name === 'zones'" [disabled]="btn.name === 'zones'"
            (click)="setColorBy(btn)">
            {{ btn.label }}
            <span class="atlas-colorby-soon" *ngIf="btn.name === 'zones'">Soon</span>
          </button>
        </div>

        <div class="color-btn-box">
          <h4 (click)="toggleCultureList()" *ngIf="currentLayerName">
            {{ currentLayerName
            }}{{
            currentLayerName.toLowerCase() === "state" ||
            currentLayerName.toLowerCase() === "culture"
            ? "s"
            : ""
            }}
            <i class="fa" [ngClass]="isCultureVisible ? 'fa-angle-down' : 'fa-angle-up'"
              style="margin-left: auto; color: #fff"></i>
          </h4>

          <!-- Off state (spec §5c): nothing selected, plain terrain -->
          <p class="atlas-colorby-off-note" *ngIf="!currentLayerName">
            The map shows plain terrain. Pick a box above to color it, or
            click anywhere to see what's at that spot.
          </p>

          <ng-container *ngIf="isCultureVisible">
            <!-- If currentLayerName is 'heightmap', show static image (a
                 real gradient key + live map tint is follow-up work - the
                 backend tile now exists (Phase 0) but isn't wired into the
                 frontend's terrain layer swap yet) -->
            <div *ngIf="currentLayerName === 'heightmap'; else showLegend">
              <div class="d-flex flex-column align-items-center justify-content-center g-10">
                <img src="assets/images/heightmap-legend.png" alt="Heightmap Legend"
                  style="width: 100%; padding: 10px" />
                <p class="height-text" (click)="navigateToElevationLink()">
                  ELEVATIONS &#40;Feet&#41;
                </p>
              </div>
            </div>

            <!-- Fallback to normal legend display (also used for Biome
                 today - the real temperature x rainfall grid is follow-up
                 work, this list is accurate real data in the meantime) -->
            <ng-template #showLegend>
              <!-- spec §5c: filter box appears once the key passes 8 entries -->
              <input *ngIf="legendData && legendData.length > 8" class="atlas-key-filter" type="text"
                placeholder="Filter {{ currentLayerName }}s..." [(ngModel)]="legendFilter" />
              <ul class="atlas-key-list" *ngIf="legendData && legendData.length > 0; else noData">
                <li *ngFor="let data of filteredLegendData()" (click)="onDynamicDataClick(data.full_name || data.name)"
                  class="">
                  <span [ngStyle]="{ 'background-color': data.color }"></span>
                  <div class="pointer pointer-cursor-link custom-width-color-btn">
                    {{ data.name }}
                  </div>
                </li>
                <li *ngIf="legendData.length > 8 && filteredLegendData().length === 0" class="atlas-key-empty">
                  No match
                </li>
              </ul>
              <ng-template #noData>
                <p style="color: white; padding-left: 10px" *ngIf="currentLayerName">No data available</p>
              </ng-template>
            </ng-template>
          </ng-container>
        </div>
      </ng-container>

      <ng-template #exploreRail>
        <p class="atlas-rail-note">
          Map colors return when you zoom back out.
        </p>
        <p class="atlas-rail-note atlas-rail-note-muted">
          The Explore rail (filters, places in view) is coming in a later
          phase of the map redesign.
        </p>
      </ng-template>
    </div>

    <!-- Status box (spec: bottom-left of the map) - compass + named zoom
         level. Temperature/rainfall already has its own live readout
         (terrain-climate-bars.ts) docked separately for now; folding it
         into this box is follow-up work once that lands. -->
    <div class="atlas-status-box">
      <button class="atlas-compass" (click)="resetNorth()" title="Reset to north">
        <span class="atlas-compass-n">N</span>
        <span class="atlas-compass-needle"></span>
      </button>
      <div class="atlas-scale">{{ mapLevel | uppercase }} &middot; {{ mapLevelZoom | number: '1.1-1' }}</div>
    </div>

    <!-- Atlas Rail Phase 3 (slice 2): ONE consolidated right panel (spec §7),
         replacing the three separate floating boxes (map key already moved
         into the rail in Phase 1; this absorbs the other two). panelMode
         picks the content; not yet the spec's [Item] [This spot] tabs
         (needs both active + a way to flip between them - follow-up). -->
    <div class="atlas-entity-panel" *ngIf="panelMode">
      <button class="atlas-entity-close" (click)="closePanel()" aria-label="Close">&times;</button>

      <ng-container *ngIf="panelMode === 'entity'">
        <p class="atlas-entity-eyebrow">{{ entitySelection?.type }}</p>
        <h3 class="atlas-entity-name">{{ entitySelectionName() }}</h3>

        <div class="atlas-entity-loading" *ngIf="entitySelectionLoading">Loading…</div>

        <dl class="atlas-entity-fields" *ngIf="!entitySelectionLoading">
          <ng-container *ngFor="let f of entityFields()">
            <dt>{{ f.label }}</dt>
            <dd>{{ f.value }}</dd>
          </ng-container>
        </dl>

        <div class="atlas-entity-footer" *ngIf="!entitySelectionLoading">
          <button class="atlas-entity-btn-primary" (click)="zoomToSelection()">Zoom to {{ entitySelectionName() }}</button>
          <button class="atlas-entity-btn-secondary" (click)="openWikiForSelection()">Wiki</button>
        </div>
      </ng-container>

      <ng-container *ngIf="panelMode === 'spot'">
        <p class="atlas-entity-eyebrow">{{ cityData ? 'City' : 'This spot' }}</p>
        <h3 class="atlas-entity-name" *ngIf="map_name">
          <span class="pointer pointer-cursor-link" (click)="navigateToWikiWorld(map_name)">{{ map_name || 'Unnamed Map' }}</span>
        </h3>

        <!-- City details, when the clicked cell has a burg -->
        <dl class="atlas-entity-fields" *ngIf="cityData">
          <ng-container *ngFor="let property of cityData | keyvalue: cityDetailsSort">
            <dt [class.pointer]="property.key === 'City Name'"
              (click)="property.key === 'City Name' ? navigateToCityNameWiki() : null">{{ property.key }}</dt>
            <dd>{{ property.value }}</dd>
          </ng-container>
        </dl>

        <!-- Land-cell ("This spot") details, same field-rendering rules as before
             (resource tooltips/links, wiki links) - unchanged logic, new frame -->
        <ng-container *ngIf="!cityData">
          <ul class="atlas-entity-spot-list" *ngIf="objectData; else elseBlockNoData">
            <ng-container *ngFor="let property of objectData | keyvalue: cellDetailsSort">
              <ng-container *ngIf="property.key !== 'id' && property.key !== 'burgs_data'">
                <li [class.bdr-top]="property.key === 'State' || property.key === 'Natural Resources'">
                  {{ property.key }}:&nbsp;

                  <ng-container *ngIf="isResourceField(property.key); else normalLink">
                    <ng-container *ngIf="splitResources(property.value)?.length > 0; else None">
                      <ng-container *ngFor="let item of splitResources(property.value); let i = index">
                        <div href="#" class="pointer pointer-cursor-link pl-2" (click)="onResourceClick(item.name || item)"
                          (mouseenter)="showResourceTooltip($event, item)" (mouseleave)="hideResourceTooltip()">
                          {{ item.name || item }}
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-template #None>
                      <span> None</span>
                    </ng-template>
                  </ng-container>

                  <ng-template #normalLink>
                    <ng-container *ngIf="isLinkField(property.key); else normalValue">
                      <ng-container *ngIf="property?.value; else noValue">
                        <div class="pointer pointer-cursor-link pl-2" (click)="navigateToDynamicLink(property.key, property.value)">
                          {{ property.value }}
                        </div>
                      </ng-container>
                      <ng-template #noValue>
                        <span>None</span>
                      </ng-template>
                    </ng-container>
                  </ng-template>
                  <ng-template #normalValue>
                    <span> {{ property.value }}</span>
                  </ng-template>
                </li>
              </ng-container>
            </ng-container>
          </ul>
          <ng-template #elseBlockNoData>
            <p class="atlas-entity-eyebrow" style="text-transform:none">No cell selected</p>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- no site footer on the play screen: the map uses the whole window -->

<!-- Resource Hover Tooltip Card -->
<div class="resource-hover-card" *ngIf="hoveredResource" [ngStyle]="tooltipStyle">
  <div class="resource-card-arrow"></div>
  <h4 class="resource-card-title">{{ hoveredResource.name }}</h4>
  <p class="resource-card-desc" *ngIf="hoveredResource.description">
    {{ hoveredResource.description }}
  </p>
  <div class="resource-card-metrics" *ngIf="hoveredResource.production !== undefined || hoveredResource.economy !== undefined || hoveredResource.rarity !== undefined || hoveredResource.processing !== undefined">
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.production || 0 }}</div>
      <div class="metric-label">Production</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.economy || 0 }}</div>
      <div class="metric-label">Economy</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.rarity || 0 }}</div>
      <div class="metric-label">Rarity</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.processing || 0 }}</div>
      <div class="metric-label">Processing</div>
    </div>
  </div>
</div>